module.exports = __webpack_public_path__ + "img/assignment.045373e5.svg";